export default function FastTravelerIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M19.8844 5.5H42.2188L32.0688 21.7531H40.1844L17.85 46.1437L21.8969 29.8906H13.7812L19.8844 5.5Z" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
    </svg>
  );
}
